import * as angular from 'angular';

"use strict";

angular.module('SignInWithGoogleModule', []);

export default 'SignInWithGoogleModule';